import { z } from "zod";
import { DynamicPricingGroupSchema } from "./IndexDynamicPricingGroupResponse";

/**
 * Skema untuk respons dari endpoint POST /dynamic-pricing/group/{id}/enable (atau /disable).
 * Menggunakan kembali skema utama untuk konsistensi data.
 */
export const ToggleStatusDynamicPricingGroupResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: DynamicPricingGroupSchema,
});

export type ToggleStatusDynamicPricingGroupResponse = z.infer<typeof ToggleStatusDynamicPricingGroupResponseSchema>;